<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4> Manage bus routes</h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard </router-link>\ Bus routes
                </div>
              </div>
              <div class="breadcrumb-right">
                <div class="card-toolbar">
                  <v-btn @click="routeCategory()" x-large text>
                    Manage route category
                  </v-btn>
                  <v-btn v-if="checkIsAccessible('route', 'create')" @click="__add()" class="mt-1 btn btn-primary"
                    style="color: #fff">
                    <v-icon small elevation="2" outlined>fas fa-plus</v-icon>&nbsp;
                    Add routes
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field label="Title" type="text" dense v-on:keyup.enter="__get" outlined
                    v-model="search.title"></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select outlined dense :items="active_statuses" item-text="title" label="Status" item-value="value"
                    v-on:keyup.enter="__get" v-model="search.active"></v-select>
                </v-col>

                <v-col cols="12" md="4" class="text-right">
                  <v-btn @click.prevent="__get" class="btn btn-primary btn-search" style="color: #fff;"
                    :loading="loading">
                    <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                    Search
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <div class="">
              <v-skeleton-loader type="table-thead" v-if="loading">
              </v-skeleton-loader>

              <v-skeleton-loader v-if="loading" type="table-row-divider@25">
              </v-skeleton-loader>
              <table class="table" v-if="!loading">
                <thead>
                  <tr class="px-3">
                    <th class="px-3 wrap-column">Category</th>
                    <th class="px-3 wrap-column">Title</th>
                    <th class="px-3 wrap-column">Status</th>
                    <th class="pr-3 text-center">Action</th>
                  </tr>
                </thead>
                <draggable v-show="routes.length > 0" @change="sort" v-model="routes" class="text-left" tag="tbody">
                  <tr v-for="(route, index) of routes" :key="route.title">
                    <td class="wrap-column">
                      {{ route.route_category_id ? route.route_category.title : "N.A" }}
                    </td>
                    <td scope="row" class="wrap-column">
                      <a href="#" @click="editRoute(route.id)" class="mr-2"> {{ route.title }}</a>

                    </td>
                    <td class="wrap-column">
                      <span
                        :class="route.is_active ? 'badge badge-success' : 'badge badge-danger'">{{ route.is_active ? 'Active' : 'Inactive' }}</span>
                    </td>
                    <td class="pr-0 text-center">
                      <b-dropdown size="sm" variant="link"
                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon" no-caret
                        right no-flip>
                        <template v-slot:button-content>
                          <slot>
                            <span>
                              <i class="flaticon-more-1"></i>
                            </span>
                          </slot>
                        </template>
                        <!--begin::Navigation-->
                        <div class="navi navi-hover ">

                          <!--                                                                              <b-dropdown-text tag="div" class="navi-item">-->
                          <!--                                                                                <a href="#" class="navi-link" @click="detail(faq.id)">-->
                          <!--                                                                                        <span class="navi-icon">-->
                          <!--                                                                                          <i class="fas fa-eye"></i>-->
                          <!--                                                                                        </span>-->
                          <!--                                                                                  <span class="navi-text"> View </span>-->
                          <!--                                                                                </a>-->
                          <!--
                                                                                                     </b-dropdown-text>-->
                                                                                                     <b-dropdown-text tag="div" class="navi-item" v-if="checkIsAccessible('route', 'list')">
                            <router-link class="navi-link" :to="{ name: 'routeSummary', params: { routeId: route.id } }"
                              custom>
                              <span class="navi-icon">
                                <i class="flaticon-bus-stop"></i>
                              </span>
                              <span class="navi-text"> Route summary </span>

                            </router-link>
                          </b-dropdown-text>
                          <b-dropdown-text tag="div" class="navi-item" v-if="checkIsAccessible('stops', 'list')">
                            <router-link class="navi-link" :to="{ name: 'routesStops', params: { routeId: route.id } }"
                              custom>
                              <span class="navi-icon">
                                <i class="flaticon-bus-stop"></i>
                              </span>
                              <span class="navi-text"> Manage Stops </span>

                            </router-link>
                          </b-dropdown-text>
                        
                          <b-dropdown-text tag="div" class="navi-item" v-if="checkIsAccessible('vehicle', 'list')">
                            <router-link class="navi-link"
                              :to="{ name: 'manage-routes-vehicles', params: { routeId: route.id } }" custom>
                              <span class="navi-icon">
                                <i class="flaticon2-delivery-truck"></i>
                              </span>
                              <span class="navi-text"> Manage Vehicles </span>

                            </router-link>
                          </b-dropdown-text>
                          <b-dropdown-text tag="div" class="navi-item" v-if="checkIsAccessible('route', 'edit')">
                            <a href="#" class="navi-link" @click="editRoute(route.id)">
                              <span class="navi-icon">
                                <i class="flaticon-edit"></i>
                              </span>
                              <span class="navi-text"> Edit </span>
                            </a>
                          </b-dropdown-text>


                          <b-dropdown-text tag="div" class="navi-item" v-if="checkIsAccessible('route', 'delete')">
                            <a href="#" class="navi-link" @click="deleteVideo(route.id)">
                              <span class="navi-icon">
                                <i class="fas fa-trash"></i>
                              </span>
                              <span class="navi-text"> Delete</span>
                            </a>
                          </b-dropdown-text>

                        </div>
                        <!--end::Navigation-->
                      </b-dropdown>
                    </td>
                  </tr>
                </draggable>
                <tr v-if="routes.length == 0">
                  <td colspan="4" class="text-center">
                    <strong>No data available to display.</strong>
                  </td>
                </tr>
              </table>
              <b-pagination v-if="routes.length > 0" class="pull-right mt-7" @input="__get" v-model="page"
                :total-rows="total" :per-page="perPage" first-number last-number></b-pagination>
            </div>
          </div>
          <create-and-update ref="route" @refresh="__get"></create-and-update>

        </div>
      </div>
    </div>
  </v-app>
</template>
<script>
import RoutesService from "@/core/services/Transport/Routes/RoutesService";
import CreateAndUpdate from "./CreateAndUpdate";
import draggable from 'vuedraggable'

const routesService = new RoutesService();

export default {
  name: "Routes-stops",
  display: "Table",
  order: 8,
  components: {
    CreateAndUpdate,
    draggable
  },
  data() {
    return {
      routes: [],
      active_statuses: [
        { title: 'Active', value: "1" },
        { title: 'Inactive', value: "0" }
      ],
      page: null,
      perPage: null,
      total: null,
      search: {
        title: null,
      },
      videoModel: false,
      video: {},
      dragging: false,
      loading: false
    };
  },
  mounted() {
    this.__get();
  },
  computed: {
    route_id() {
      return this.$route.params.routeId;
    }
  },
  methods: {
    __get() {
      this.loading = true;
      routesService
        .paginate(this.search)
        .then(response => {
          this.routes = response.data.data;
          this.page = response.data.meta.current_page;
          this.total = response.data.meta.total;
          this.perPage = response.data.meta.per_page;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          // console.log(error);
        });
    },
    __add() {
      this.$refs["route"].createRoute();
    },
    editRoute(id) {
      this.$refs["route"].editRoute(id);
    },
    routeCategory() {
      this.$router.push({
        name: "route-category",
      });
    },
    deleteVideo(id) {
      this.$confirm({
        message: `Are you sure you want to delete this item?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            routesService
              .delete(id)
              .then(response => {
                this.__get();
              })
              .catch(error => {
                //console.log(error);
              });
          }
        }
      });
    },
    sort() {
      routesService.sort(this.routes).then((res) => {
        this.$snotify.success("Sorted");
        this.__get()
      }).catch(err => {
        this.$snotify.success("Sorted Error");
      })
    },

  }
};
</script>
<style scoped>
.buttons {
  margin-top: 35px;
}
</style>
